module.exports = __webpack_public_path__ + "img/bmcl_gallery9.1ae1165d.jpg";